import type { ItemDefInput } from '../../schemas/items';

/**
 * Studio NANO props (docs/design/studio-nano.md §6). Right spot is the stage around the pose mark; the first
 * set comes with the studio (unl_studio), the second with Tiếng lành Lv2. Granny's tripod is never sold.
 */
function prop(id: ItemDefInput['id'], overrides: Partial<ItemDefInput>): ItemDefInput {
  const kind = id.startsWith('fur_') ? 'furniture' : 'decor';
  return {
    id,
    kind,
    nameKey: `item.${id}.name`,
    loreKey: `item.${id}.lore`,
    shopTab: kind === 'furniture' ? 'furniture' : 'decor',
    layer: 'object',
    footprint: { w: 1, h: 1 },
    rotations: 2,
    tags: ['studio'],
    homeTags: ['zone:stage'],
    unlockId: 'unl_studio',
    material: 'wood',
    sources: [{ kind: 'catalog' }],
    sprite: { frame: `item_${id}` },
    ...overrides,
  };
}

export const STUDIO_FURNITURE: readonly ItemDefInput[] = [
  prop('fur_studio_backdrop', {
    footprint: { w: 2, h: 1 },
    tags: ['studio', 'backdrop'],
    homeTags: ['wall-adjacent'],
    themeTags: ['cozy'],
    buyPrice: 160,
    material: 'paper',
    sources: [{ kind: 'catalog' }, { kind: 'story', chapterId: 'ch6' }],
  }),
  prop('fur_studio_stool', {
    tags: ['studio', 'seat', 'chair'],
    themeTags: ['cute'],
    buyPrice: 70,
  }),
  prop('fur_studio_flower_arch', {
    footprint: { w: 2, h: 1 },
    tags: ['studio', 'plant', 'flower'],
    themeTags: ['garden', 'sweet'],
    unlockId: 'unl_studio_lv2',
    buyPrice: 180,
    material: 'plant',
  }),
];

export const STUDIO_DECOR: readonly ItemDefInput[] = [
  prop('dec_studio_softbox', {
    tags: ['studio', 'light', 'lamp'],
    themeTags: ['office'],
    buyPrice: 90,
    material: 'fabric',
    sources: [{ kind: 'catalog' }, { kind: 'story', chapterId: 'ch6' }],
  }),
  prop('dec_studio_reflector', {
    tags: ['studio', 'light'],
    themeTags: ['office'],
    buyPrice: 60,
    material: 'fabric',
  }),
  prop('dec_studio_tripod', {
    tags: ['studio', 'camera', 'grandma'],
    themeTags: ['cozy'],
    unlockId: undefined,
    material: 'metal',
    sources: [{ kind: 'story', chapterId: 'ch6' }],
  }),
  prop('dec_studio_balloons', {
    tags: ['studio', 'party'],
    themeTags: ['kids', 'cute'],
    unlockId: 'unl_studio_lv2',
    buyPrice: 50,
    material: 'paper',
  }),
  prop('dec_studio_photo_wall', {
    layer: 'wall',
    footprint: undefined,
    wallSpan: 2,
    tags: ['studio', 'photo'],
    homeTags: ['wall'],
    themeTags: ['cozy', 'cute'],
    unlockId: 'unl_studio_lv2',
    buyPrice: 110,
    material: 'paper',
  }),
];
